import { observable } from "mobx";
import { api, api_adm, apiOperacao } from "../../api";
import { toast } from "react-toastify";

class _TribuNacionalStore {

  obs = observable({
    tribu_nacional: [] as any,
    loading: false as boolean
  })

  async handleLoadTribuNacional() {

    try {

      let resp = await apiOperacao("legislacoes").get("/legislacoes/codigos/tribu-nacional")

      this.obs.tribu_nacional = []

      if (resp.data.length) {

        this.obs.tribu_nacional = resp.data

      }

    } catch (ex) { }

  }

  get(codigo: any): any {

    return this.obs.tribu_nacional.find(x => x.codigo == codigo);

  }

  async handleCreateTribuNacional(data: any) {

    let resp = await api_adm.post("/api/admin/codigos/tribu-nacional/create", data)

    if (resp.data.ok) {

      toast.success('Tributação Nacional criada com sucesso!', {});

      return true

    } else {

      toast.error(resp.data.msg, {});

    }

    return false

  }

  async handleUpdateTribuNacional(data: any) {

    let resp = await api_adm.post("/api/admin/codigos/tribu-nacional/update", data)

    if (resp.data.ok) {

      toast.success('Tributação Nacional atualizada com sucesso!', {});

      return true

    } else {

      toast.warning(resp.data.msg, {});

    }

    return false

  }

  async handleDeleteTribuNacional(id: string) {

    let resp = await api_adm.delete(`/api/admin/codigos/tribu-nacional/${id}`)

    if (resp.data.ok) {

      toast.success('Tributação Nacional deletada com sucesso!', {});

      return true

    } else {

      toast.error(resp.data.msg, {});

    }

    return false

  }

}

export const TribuNacionalStore = new _TribuNacionalStore();
